import type { Regimen } from "./types.ts";
import {
  BREAKFAST_CARBS,
  SNACK_CARBS,
  MAIN_CARBS,
  DINNER_CARBS,
  FULL_PROTEINS,
  DINNER_PROTEINS,
  SNACK_PROTEINS,
  CARDIO_REST_LUNCH_PROTEINS,
  FRUITS,
  FATS,
  VEGETABLES_FRESH,
  VEGETABLES_SMALL,
  EGG_YOLK_NOTE,
  GELATIN_NOTE,
} from "./options.ts";

export const restRegimen: Regimen = {
  id: "rest",
  name: "Días sin Entrenamiento",
  badge: "R",
  description: "Régimen para días de descanso sin actividad física programada",
  meals: [
    {
      name: "breakfast",
      label: "Desayuno",
      choices: [
        {
          category: "carb",
          pick: 1,
          canRepeat: false,
          options: BREAKFAST_CARBS,
        },
        {
          category: "fruit",
          pick: 1,
          canRepeat: false,
          options: FRUITS,
        },
        {
          category: "protein",
          pick: 4,
          canRepeat: true,
          note: EGG_YOLK_NOTE,
          options: FULL_PROTEINS,
        },
        {
          category: "fat",
          pick: 1,
          canRepeat: false,
          options: FATS,
        },
      ],
    },
    {
      name: "lunch",
      label: "Almuerzo",
      choices: [
        {
          category: "carb",
          pick: 2,
          canRepeat: true,
          options: MAIN_CARBS,
        },
        {
          category: "protein",
          pick: 1,
          canRepeat: false,
          options: CARDIO_REST_LUNCH_PROTEINS,
        },
        {
          category: "vegetable",
          pick: 1,
          canRepeat: false,
          options: VEGETABLES_FRESH,
        },
        {
          category: "fat",
          pick: 2,
          canRepeat: true,
          options: FATS,
        },
      ],
    },
    {
      name: "mid-afternoon",
      label: "Media Tarde",
      choices: [
        {
          category: "carb",
          pick: 1,
          canRepeat: false,
          options: SNACK_CARBS,
        },
        {
          category: "protein",
          pick: 2,
          canRepeat: true,
          note: GELATIN_NOTE,
          options: SNACK_PROTEINS,
        },
      ],
    },
    {
      name: "dinner",
      label: "Cena",
      choices: [
        {
          category: "carb",
          pick: 2,
          canRepeat: true,
          options: DINNER_CARBS,
        },
        {
          category: "protein",
          pick: 4,
          canRepeat: true,
          note: EGG_YOLK_NOTE,
          options: DINNER_PROTEINS,
        },
        {
          category: "vegetable",
          pick: 1,
          canRepeat: false,
          optional: true,
          options: VEGETABLES_SMALL,
        },
        {
          category: "fat",
          pick: 1,
          canRepeat: false,
          options: FATS,
        },
      ],
    },
  ],
};
